const googleAutocomplete = async text =>
  new Promise((resolve, reject) => {
    if (!text) {
      return reject("Need valid text input")
    }

    if (typeof window === "undefined") {
      return reject("Need valid window object")
    }

    try {
      new window.google.maps.places.AutocompleteService().getPlacePredictions(
        {
          input: text,
          types: ['geocode']
        },
        (response) => {
          if (response) {
            return resolve(response)
          }
          return reject('No Data')
        }
      )
    } catch (e) {
      reject(e)
    }
  })

export default googleAutocomplete;
